import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';
import white from 'sushiweb/tokens/color/white';
import ZImage from 'sushiweb/ZImage';

export const Container = styled.div`
  height: 100%;
  width: 100%;
  background: ${white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    font-weight: 400;
    font-size: 1.6rem;
    color: ${grey.z700};
  }
`;

export const ZLogoWrapper = styled(ZImage)`
  margin-bottom: 1.6rem;
`;

export const ZImageWrapper = styled(ZImage)`
  margin: 3.2rem 0 3.6rem;
`;
